interface GetOptionsFn<T> {
	(): T[];
	data?: T[];
}

export function getListLazy<T>(getListCallback: GetOptionsFn<T>) {
	return () => {
		if (getListCallback.data == null) {
			getListCallback.data = getListCallback();
		}
		return getListCallback.data;
	};
}
